$(document).ready(function ($) {
    if ($('#main').hasClass('case-study-new')) {
        first();
        checkScrollButton();
        scrollResizeDesktop();

        document.querySelectorAll('.slider-container').forEach(container => {
            let currentIndex = 0;
            const previews = container.querySelectorAll('.preview-image');
            const slides = container.querySelectorAll('.slide');

            previews.forEach((preview, index) => {
                preview.addEventListener('click', () => {
                    currentIndex = index;
                    updateSlider();
                });
            });

            function updateSlider() {
                slides.forEach((slide, index) => {
                    if (index === currentIndex) {
                        slide.style.display = 'block';
                        previews[index].classList.add('active');
                    } else {
                        slide.style.display = 'none';
                        previews[index].classList.remove('active');
                    }
                });
            }

            updateSlider();
        });



        if (window.innerWidth < 1201) {
            var scrollLink = $('.case_study__navigation-item');
            scrollLink.on('click', function () {
                var $el = $(this),
                    id = $el.attr('href');
                var heightPopup = 0;

                if ($('.js-mobi-popup').length && $('.js-mobi-popup').css('display') != 'none') {
                    heightPopup = $('.js-mobi-popup').outerHeight();
                }

                var down = heightPopup;

                if ($(window).width() <= 1200) {
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    $(id).siblings().removeClass('active');
                    $(id).addClass('active');
                    down += 140;
                }

                $('html, body').animate({
                    scrollTop: $(id).offset().top - down
                }, 500);

                setTimeout(() => {
                    $('.case_study__navigation hr').css({
                        width: $(this).outerWidth()
                    })
                    centerLine();
                }, 500);

                scrollToVisible(this)

                return false;
            });

            $(window).scroll(function () {
                var scrollDistance = $(window).scrollTop() + 300;
                var items = $('.section-case').get();
                if (items.length > 0) {
                    var techFocusLastItemPosition = items[items.length - 1].getBoundingClientRect().top;
                }

                $('.section-case').each(function () {
                    if ($(this).position().top < scrollDistance) {
                        var $selector = $('a[href="#' + $(this).attr('id') + '"]');
                        $($selector).siblings().removeClass('active');
                        $($selector).addClass('active');
                        if (window.innerWidth < 1201) {
                            scrollToVisible($selector)
                        }

                        if (techFocusLastItemPosition > 200) {
                            $('.case_study__navigation hr').css({
                                width: $($selector).outerWidth()
                            })
                            centerLine();
                        }

                    }
                })
            })
        }

        function scrollToVisible(element) {
            const scrollContainer = document.querySelector(".case_study__navigation");
            const containerScrollLeft = scrollContainer.scrollLeft;
            const containerWidth = scrollContainer.clientWidth;
            let elementLeft = 0
            if ($(element).offset() !== undefined) {
                elementLeft = $(element).offset().left;
            }

            const itemLeft = elementLeft - scrollContainer.offsetLeft;
            const itemWidth = $(element).outerWidth();

            if (itemLeft + itemWidth < 0) {
                scrollContainer.scrollLeft = containerScrollLeft + itemLeft;
            } else if (itemLeft + itemWidth > containerWidth) {
                scrollContainer.scrollLeft = containerScrollLeft + itemLeft + itemWidth - containerWidth;
            }

            return false;
        }

        function first() {
            if (window.innerWidth < 1201) {
                var posts = $('.section-case');

                if (posts.hasClass('active') || findVisibleElement(posts)) {
                    var elements = $('.section-case');
                    var visibleElement = findVisibleElement(elements);
                    var $selector = $('a[href="#' + visibleElement.id + '"]');
                    $($selector).addClass('active');
                    centerLine();
                } else {
                    posts.first().addClass('active');
                    var $id = posts.first().attr('id');
                    var $selector = $('a[href="#' + $id + '"]');
                    $($selector).addClass('active');
                    setTimeout(() => {
                        centerLine()
                    }, 150);
                }
                $('.case_study__navigation hr ').css({
                    display: 'block'
                })
            }
        }

        function centerLine() {

            const $scrollDemo = document.querySelector(".case_study__navigation");
            var $position = ($('.case_study__navigation hr').outerWidth() - $('.case_study__navigation-contain a.active').outerWidth()) / 2;
            $('.case_study__navigation hr').css({
                left: $('.case_study__navigation-contain a.active').position().left - $position + $scrollDemo.scrollLeft
            });
        }

        function scrollResizeDesktop() {

            var scrollableContent = $('.case_study__navigation');
            var isDragging = false;
            var startPosition = 0;
            var scrollPosition = 0;

            scrollableContent.on('mousedown', function (event) {
                if (event.button === 0) {
                    isDragging = true;
                    startPosition = event.clientX;
                    scrollPosition = scrollableContent.scrollLeft();
                    event.preventDefault();
                }
            });

            $(document).on('mouseup', function (event) {
                if (event.button === 0) {
                    isDragging = false;
                    event.preventDefault();
                }
            });

            $(document).on('mousemove', function (event) {
                if (isDragging) {
                    var distance = event.clientX - startPosition;
                    scrollableContent.scrollLeft(scrollPosition - distance);
                    event.preventDefault();
                }
            });
        }

        function findVisibleElement(elements) {
            for (var i = 0; i < elements.length; i++) {
                if (isElementInViewport(elements[i])) {
                    return elements[i];
                }
            }
            return null;
        }
        function isElementInViewport(el) {
            var rect = el.getBoundingClientRect();

            return (
                rect.bottom > 200 &&
                rect.top < window.innerHeight
            );
        }

        function checkScrollButton() {
            const scrollContainer = document.querySelector(".case_study__navigation");
            if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
                $('.right-button-case').addClass('case-scroll-max');
            } else {
                $('.right-button-case').removeClass('case-scroll-max');
            }
            if (scrollContainer.scrollLeft <= 0) {
                $('.left-button-case').addClass('case-scroll-max');
            } else {
                $('.left-button-case').removeClass('case-scroll-max');
            }
        }

        document.querySelector('.right-button-case').addEventListener('click', function () {
            const scrollContainer = document.querySelector('.case_study__navigation');
            const scrollAmount = 100;
            const scrollDuration = 500;

            const startScrollLeft = scrollContainer.scrollLeft;
            const targetScrollLeft = startScrollLeft + scrollAmount;
            let startTime;

            function scroll(timestamp) {
                if (!startTime) {
                    startTime = timestamp;
                }

                const elapsed = timestamp - startTime;

                if (elapsed < scrollDuration) {
                    const progress = elapsed / scrollDuration;
                    scrollContainer.scrollLeft = startScrollLeft + progress * scrollAmount;
                    requestAnimationFrame(scroll);
                } else {
                    scrollContainer.scrollLeft = targetScrollLeft;
                }
            }
            requestAnimationFrame(scroll);
            setTimeout(() => {
                checkScrollButton();
            }, scrollDuration);
        });
        document.querySelector('.left-button-case').addEventListener('click', function () {
            const scrollContainer = document.querySelector('.case_study__navigation');
            const scrollAmount = 100;
            const scrollDuration = 500;

            const startScrollLeft = scrollContainer.scrollLeft;
            const targetScrollLeft = startScrollLeft - scrollAmount;
            let startTime;
            function scroll(timestamp) {
                if (!startTime) {
                    startTime = timestamp;
                }

                const elapsed = timestamp - startTime;

                if (elapsed < scrollDuration) {
                    const progress = elapsed / scrollDuration;
                    scrollContainer.scrollLeft = startScrollLeft + progress * (targetScrollLeft - startScrollLeft);
                    requestAnimationFrame(scroll);
                } else {
                    scrollContainer.scrollLeft = targetScrollLeft;
                }
            }
            requestAnimationFrame(scroll);
            setTimeout(() => {
                checkScrollButton();
            }, scrollDuration);


        });
        var scrollableElements = document.getElementsByClassName("case_study__navigation");

        for (var i = 0; i < scrollableElements.length; i++) {
            scrollableElements[i].addEventListener("scroll", function(event) {
                checkScrollButton();
            });
        }
    }

})